import ReactDOM from "react-dom";
import promiseFinally from "promise.prototype.finally";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { useStrict } from "mobx";
import { Provider } from "mobx-react";
import App from "./components/App";
import authStore from "./stores/authStore";
import commonStore from "./stores/commonStore";
import navigatorStore from "./stores/navigatorStore";
import userStore from "./stores/userStore";
import profileStore from "./stores/profileStore";
import generalStore from "./stores/generalStore";
import searchPageArtworksStore from "./stores/artworksStores/searchPageArtworksStore";
import landingPageArtworksStore from "./stores/artworksStores/landingPageArtworksStore";
import likeAndUnlikeStore from "./stores/artworksStores/likeAndUnlikeStore";
import artworksStore from "./stores/artworksStores/artworksStore";
import categoryPageArtworksStore from "./stores/artworksStores/categoryPageArtworksStore";
import artistDetails from "./stores/artistsStore/artistDetailsStore";
import artistsListStore from "./stores/artistsStore/artistsListStore";
import followAndLikeStore from "./stores/artistsStore/followAndLikeStore";
import requestsStore from "./stores/OrdersStore/requestsStore";
import ScrollMemory from "react-router-scroll-memory";
import "bulma/css/bulma.css";
import "./styles/app.css";
import "./styles/common_elements.css";
import "bootstrap/dist/css/bootstrap.min.css";

// import {fbid} from
import ENV from './env/index.js'
// import 'semantic-ui-css/semantic.min.css'


const stores = {
  authStore,
  commonStore,
  userStore,
  profileStore,
  navigatorStore,
  searchPageArtworksStore,
  landingPageArtworksStore,
  artworksStore,
  artistDetails,
  followAndLikeStore,
  likeAndUnlikeStore,
  generalStore,
  artistsListStore,
  requestsStore,
  categoryPageArtworksStore
};

// For easier debugging
window._____APP_STATE_____ = stores;

promiseFinally.shim();
useStrict(true);
// console.log(ENV);

ReactDOM.render((
  <Provider {...stores}>
    <BrowserRouter>
      <div>
        <ScrollMemory />
        <App />
      </div>
    </BrowserRouter>
  </Provider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js